module.exports = __webpack_public_path__ + "img/P6-zh.5d5228a5.png";